import { REFERRAL_BASE_URL } from "@/data/urls";
import axios from "axios";

export type TUserEarning = {
  claimablePoints: number;
  points: number;
  count: number;
  level: string;
  rewards: {
    hasCurrent: boolean;
    hasPending: boolean;
    imageUrl: string | null;
  };
};

export type TUserCreditData = {
  data: TUserEarning;
  status: string;
  error: string;
};

const getUserCredit = async (userId?: string, accessToken?: string) => {
  // console.log("getUserCredit", userId, accessToken);
  if (!userId || !accessToken) return;

  const apiURL = `${REFERRAL_BASE_URL}?type=get_credits`;

  const data = {
    userId: userId,
  };

  const options = {
    headers: {
      Authorization: accessToken,
    },
  };

  const res = await axios.post(apiURL, data, options);

  return res.data as TUserCreditData;
};

export default getUserCredit;
